import {fetch} from "utils/dataAccess";

/**
 * Asks the API whether an invoice short code is still free in the current organization.
 * A conflict is reported even when the other retailer only inherits the code from its name
 * (source: "implicit"), because invoice numbers would collide all the same.
 *
 * @param {string} code         the 1 to 3 letter code being typed
 * @param {string} [retailerId] uuid of the retailer being edited, excluded from the check
 *
 * @return {Promise<{code: string, available: boolean, conflicts: {id: string, name: string, source: string}[]}>}
 */
export default function invoiceShortFormAvailability(code, retailerId) {
    const params = new URLSearchParams({code});

    if (retailerId) {
        params.set("retailer", retailerId);
    }

    return fetch(`/retailers/invoice_short_form_availability?${params.toString()}`)
        .then(response => response.json());
}
